'use strict'

const parseRmUrl = require('../../../functions/parseRmUrl')

class Widgets {

  constructor ($scope, $http, $mdDialog, wsEvents) {
    this.$scope = $scope
    this.$http = $http
    this.$mdDialog = $mdDialog
    this.wsEvents = wsEvents
    this.widgetsLoaded = {}
    this.getWidgets(window.CONFIG.station_id)
    this.registered = {}
    this.saveCallbacks = {}
    this.authorizationKeys = {}
    this.popupCalledFrom = null
    this.currentPopup = null

    this.events = {}

    this.backgroundEvents = {
      'getAuthorizationKey': [this.updateAuthorizationKey.bind(this)], // @todo remove
      'requestAuthorizationKey': [this.updateAuthorizationKey.bind(this)],
      'save-callback': [this.saveCallback.bind(this)],
      'popup': [this.popupWidget.bind(this)],
      'popupMessage': [this.sendPopupMessage.bind(this)],
      'closePopupWidget': [this.closePopupWidget.bind(this)],
      'widgetLoadedDone': [this.widgetLoadedDone.bind(this)],
      'publishToOthers': [this.publishToOthers.bind(this)],
      'fetchRequest': [this.fetchRequest.bind(this)],
      'updateUrl': [this.updateUrl.bind(this)],
      'registered': [this.widgetRegisteredEvent.bind(this), true],
    }

    window.addEventListener('message', this.handlePostMessage.bind(this), false)

    return {
      getWidgetsByType: this.getWidgetsByType.bind(this),
      getWidgetById: this.getWidgetById.bind(this),
      reloadWidgetsData: this.reloadWidgetsData.bind(this),

      unRegisterWidget: this.unRegisterWidget.bind(this),
      sendMessage: this.sendMessage.bind(this),
      getConnectionsFromTypeId: this.getConnectionsFromTypeId.bind(this),
      saveWidgetsForTypeId: this.saveWidgetsForTypeId.bind(this),

      createWidgetFrame: this.createWidgetFrame.bind(this),
    }
  }

  //-------------------------------//
  // Popup functions               //
  //-------------------------------//
  sendPopupMessage (data) {
    if (this.popupCalledFrom === null) return
    switch (data.id) {
      case 'popup':
        this.sendMessage(this.popupCalledFrom, 'popupMessage', data.actionData)
        break
      case this.popupCalledFrom:
        this.sendMessage('popup', 'popupMessage', data.actionData)
        break
    }
  }

  closePopupWidget (data) {
    if (this.currentPopup && (data.id === this.popupCalledFrom || data.id === 'popup')) {
      this.currentPopup.cancel()
      this.currentPopup = null
    }
  }

  generateUrl (url, parameters = {}) {
    let nextQueryParam = (url.indexOf('?') === -1) ? '?' : '&'
    parameters.stationId = parameters.stationId || window.CONFIG.station_id
    parameters.userId = parameters.userId || window.CONFIG.user_id
    parameters.origin = parameters.origin || location.origin
    for (let parameter in parameters) {
      if (parameters.hasOwnProperty(parameter)) {
        url += nextQueryParam +
          encodeURI(parameter) + '=' +
          encodeURIComponent(parameters[parameter])
        nextQueryParam = '&'
      }
    }
    return url
  }

  getScreenSize () {
    return {
      width: document.body.clientWidth - 45,
      height: document.body.clientHeight - 45,
    }
  }

  mergeObject (object, mergeObject) {
    for (let key in mergeObject) {
      if (mergeObject.hasOwnProperty(key)) {
        object[key] = mergeObject[key]
      }
    }
    return object
  }

  addWindowResizeListener (widgetId, widgetType) {

    const screenResizeAllowedWidgetsTypes = [
      'popup', 'rundown_item',
    ]

    if (screenResizeAllowedWidgetsTypes.indexOf(widgetType) === -1) {
      const func = () => undefined
      return {
        init: func,
        close: func,
      }
    }

    let windowResizeListener = event => {
      this.sendMessage(widgetId, 'screenResize', this.getScreenSize())
    }

    return {
      init: () => window.addEventListener('resize', windowResizeListener),
      close: () => window.removeEventListener('resize', windowResizeListener),
    }
  }

  popupWidget (data) {
    this.popupCalledFrom = data.id

    const popupCalledFromWidget = this.registered[data.id]

    let widgetId = 'popup'

    let frameUrl = data.actionData.frameUrl
    switch (frameUrl) {
      case 'image':
        frameUrl = '/rm-widgets/popup/image'
        break
      case 'video':
        frameUrl = '/rm-widgets/popup/video'
        break
    }

    let url = this.generateUrl(frameUrl, {
      widgetCode: widgetId,
    })

    this.$mdDialog.show({
      template: `<md-dialog aria-label="Popup dialog" id="popupElement"></md-dialog>`,
      parent: angular.element(document.body),
      clickOutsideToClose: true,
      multiple: true,
      controller: ['$scope', '$mdDialog', '$element', ($scope, $mdDialog, $element) => {
        this.currentPopup = $mdDialog

        const dialog = $element.find('md-dialog')[0]

        dialog.classList.add('widget-popup')

        this.createWidgetFrame(
          widgetId,
          {
            url: url,
            type: widgetId,
            application_id: popupCalledFromWidget.applicationId,
          },
          {},
          'popup',
          (data, iframe) => {
            switch (data.action) {
              case('registered'):
                this.sendMessage(this.popupCalledFrom, 'popupLoaded')
                break
              case('height-update'):
                dialog.style.height = data.actionData.newHeight + 'px'
                break
              case('width-update'):
                dialog.style.width = data.actionData.newWidth + 'px'
                break
            }
          },
          () => [this.mergeObject(data.actionData.initializeContent, this.getScreenSize())],
          {}, // @todo add extra data fields
          popupCalledFromWidget.stationId
        ).then(iframe => {
          dialog.appendChild(iframe)
        })
      }],
    }).catch(() => {
      this.unRegisterWidget(widgetId)
      this.sendMessage(this.popupCalledFrom, 'popupClose')
      this.popupCalledFrom = null
    })
  }

  //-------------------------------//
  // End popup functions           //
  //-------------------------------//

  saveCallback (data) {
    this.saveCallbacks[data.id]()
  }

  updateAuthorizationKey (data) {
    const registeredWidget = this.registered[data.id]
    this.getAuthorizationKey(
      registeredWidget.applicationId,
      registeredWidget.widgetId,
      registeredWidget.stationId,
      registeredWidget.initData(),
      true
    ).then(authorizationKey => {
      if (authorizationKey.key) {
        this.sendMessage(data.id, 'authorizationKey', authorizationKey)
      }
    })
  }

  updateUrl (data) {
    this.registered[data.id].origin = this.getOrigin(data.actionData)
    this.sendMessage(data.id, 'updatedWidgetUrl', data.actionData)
  }

  widgetRegisteredEvent (data) {
    this.sendMessage(data.id, 'initialize', this.registered[data.id].initData())
  }

  createWidgetFrame (id, widget, parameters = {}, typeId, messageHandler, initCallback, extraDataObject, stationId, forceType, onStation) {

    if (this.registered[id]) {
      throw new Error('you cant register an widget twice with the same unique id! uniqueId: ' + id)
    }

    stationId = stationId || window.CONFIG.station_id
    onStation = onStation || window.CONFIG.system_name

    const windowResizeManager = this.addWindowResizeListener(id, forceType || typeId)
    windowResizeManager.init()

    const initData = () => {
      const [
        content = null,
        extraMessageRootData,
      ] = (initCallback() || [])

      let message = {
        extraData: this.getExtraData(widget.extra_data, extraDataObject),
        settings: registeredWidget.settings || {},
        stationId: window.CONFIG.station_id,
        userId: window.CONFIG.user_id,
        timezone: window.CONFIG.timezone,
        content: content,
        auth: {},
      }

      if (extraMessageRootData && typeof extraMessageRootData === 'object') {
        for (let itemKey in extraMessageRootData) {
          if (extraMessageRootData.hasOwnProperty(itemKey)) {
            message[itemKey] = extraMessageRootData[itemKey]
          }
        }
      }

      return message
    }

    const hasWidgetsOfStation = this.hasWidgetsOfStation(stationId)

    let widgetOrigin = this.getOrigin(widget.url)
    const registeredWidget = this.registered[id] = {
      id: id,
      loaded: false,
      typeId: typeId,
      type: widget.type,
      data_key: widget.data_key,
      origin: widgetOrigin,
      widgetId: widget.id,
      settings: widget.settings,
      applicationId: widget.application_id,
      stationId: stationId,
      iframe: null,
      handler: messageHandler,
      initData: initData,
      onStation: onStation,
    }

    registeredWidget.close = () => {
      console.log(id, { 'widget close': registeredWidget })
      windowResizeManager.close()
    }

    registeredWidget.save = () => {
      return new Promise(resolve => {
        if (registeredWidget.loaded === false) {
          console.log(id, { 'save auto resolve': registeredWidget, 'widget loaded': false })
          return resolve()
        }

        console.log(id, { 'send save to widget': registeredWidget })
        this.sendMessage(id, 'save', {})

        this.saveCallbacks[id] = () => {
          console.log(id, { 'got save cb from widget': registeredWidget })
          resolve()
          delete this.saveCallbacks[id]
        }
      })
    }

    return this.getAuthorizationKey(widget.application_id, widget.id, stationId, initData(), true)
      .then(authorizationKey => {
        if (!hasWidgetsOfStation) {
          return this.getStationSocket(stationId)
            .then(() => authorizationKey)
        }
        return authorizationKey
      })
      .then(authorizationKey => {
        // create the frame element
        let widgetFrame = document.createElement('iframe')
        registeredWidget.iframe = widgetFrame

        // place the query parameters in the url
        parameters.systemName = widget.system_name
        parameters.widgetCode = id
        parameters.stationId = stationId

        if (stationId !== window.CONFIG.station_id) {
          parameters.executeStation = window.CONFIG.station_id
        }

        if (authorizationKey.key !== undefined) {
          parameters.authorizationKey = authorizationKey.key
          parameters.jwtKey = authorizationKey.jwtKey
        }

        // set url to frame source
        widgetFrame.src = this.generateUrl(widget.url, parameters)

        return widgetFrame
      })
  }

  getStationSocket (stationId) {
    if (this.events[stationId]) {
      return Promise.resolve(this.events[stationId])
    }

    const ws = this.wsEvents(`widgets.publish.${stationId}`)
    this.events[stationId] = ws

    ws.messageCallback((data) => {
      this.sendMessage(data.uniqueWidgetId, 'publishToOthers', data.message)
    })

    // ws.onclose = () => { // @todo
    //     delete this.events[stationId];
    // };

    return Promise.resolve(ws)

  }

  getExtraData (extraData, matchObj) {
    matchObj = matchObj || {}
    extraData = extraData || []

    const returnObj = {}
    extraData.forEach(fieldName => {
      let value = null
      const matches = fieldName.match(/^([\w]+)\.(.*)$/)
      if (matches) {
        const [, matchType, dataPath] = matches
        value = matchObj[matchType]

        if (value === undefined) {
          console.error(`No "${matchType}" supported by the widgets extra data field`)

        } else {
          try {
            dataPath.split('.').forEach(itemFieldPiece => {
              if (value) {
                if (typeof value.get === 'function') {
                  value = value.get(itemFieldPiece)
                } else {
                  value = value[itemFieldPiece]
                }
              }
            })
          } catch (err) {
            console.error(err)
            value = null
          }
        }
      } else {
        console.error(`Extra data ${fieldName} could not be parsed`)
      }

      // If the value has a observe function it probably a Y object
      if (value && typeof value.observe === 'function') {
        value = value.toString()
      }

      returnObj[fieldName] = value
    })
    return returnObj
  }

  getWidgets (stationId, reloadWidgets) {
    if (!this.widgetsLoaded[stationId] || reloadWidgets) {
      this.widgetsLoaded[stationId] = new Promise(resolve => {
        this.$http.get('widgets/by-type/' + stationId)
          .then(response => resolve(response.data))
      })
    }
    return this.widgetsLoaded[stationId]
  }

  getAuthKeyCacheKey (id) {
    const registeredWidget = this.registered[id]
    if (!registeredWidget) return ''
    return [
      registeredWidget.widgetId,
      registeredWidget.applicationId,
      registeredWidget.stationId,
    ].join('|')
  }

  getAuthorizationKey (applicationId, id, stationId, initData, getNew = false) {
    const authKey = this.getAuthKeyCacheKey(id)
    if (!this.authorizationKeys[authKey] || getNew) {
      this.authorizationKeys[authKey] = (
        this.$http.post('widgets/get-authorization-key/' + applicationId + '/' + stationId, initData)
      ).then(response => {
        if (response.data.error === true) {
          console.warn('JWT credentials not inserted in application')
          return {}
        }
        return response.data
      })
    }
    return this.authorizationKeys[authKey]
  }

  getWidgetsByType (type, stationId) {
    return new Promise(resolve => {
      this.getWidgets(stationId || window.CONFIG.station_id)
        .then(widgets => resolve(widgets[type] || []))
    })
  }

  getWidgetById (id, type, stationId) {
    return new Promise(resolve => {
      this.getWidgets(stationId || window.CONFIG.station_id).then(widgets => {
        if (type) {
          if (widgets[type]) {
            for (let i = 0; i < widgets[type].length; i++) {
              if (widgets[type][i] && widgets[type][i].id == id) {
                return resolve(widgets[type][i])
              }
            }
          }
        }

        for (type in widgets) {
          if (widgets.hasOwnProperty(type)) {
            for (let i = 0; i < widgets[type].length; i++) {
              if (widgets[type][i] && widgets[type][i].id == id) {
                return resolve(widgets[type][i])
              }
            }
          }
        }

        resolve(null)
      })
    })
  }

  reloadWidgetsData (stationId) {
    this.getWidgets(stationId || window.CONFIG.station_id, true)
  }

  getConnectionsFromTypeId (typeId) {
    const registeredWidgets = this.registered

    let connections = {}
    for (let id in registeredWidgets) {
      if (registeredWidgets.hasOwnProperty(id)) {
        if (registeredWidgets[id].typeId == typeId) {
          connections[id] = registeredWidgets[id]
        }
      }
    }

    return connections
  }

  // Widget lib connection
  handlePostMessage (event) {
    if (typeof event.data !== 'object' || !event.data.id) return

    let registeredData = this.registered[event.data.id]
    if (registeredData && event.origin == registeredData.origin) {

      const backgroundEvent = this.backgroundEvents[event.data.action]
      if (backgroundEvent !== undefined) {
        backgroundEvent[0](event.data)
        // Check if the event must be prevented
        if (!backgroundEvent[1]) return
      }

      registeredData.handler(event.data, registeredData.iframe)
    }
  }

  hasWidgetsOfStation (stationId) {
    for (let id in this.registered) {
      if (this.registered.hasOwnProperty(id)) {
        if (this.registered[id].stationId == stationId) {
          return true
        }
      }
    }

    return false
  }

  widgetLoadedDone (data) {
    let widget = this.registered[data.id]
    widget.loaded = true
    widget.iframe.contentWindow.postMessage({
      action: 'registerAs',
      actionData: { type: widget.type },
    }, '*')
  }

  publishToOthers (data) {
    if (this.registered[data.id]) {
      const { stationId } = this.registered[data.id]

      this.getStationSocket(stationId)
        .then(conn => (
          conn.send({
            uniqueWidgetId: data.id,
            message: data.actionData,
          })
        ))
    }
  }

  fetchRequest (data) {
    if (this.registered[data.id]) {
      const httpOptions = data.actionData
      const { onStation, stationId } = this.registered[data.id]

      const url = parseRmUrl(httpOptions.url, onStation)

      if (stationId !== window.CONFIG.station_id) {
        url.searchParams.append('executeStation', window.CONFIG.station_id)
      }

      httpOptions.url = url.href

      this.$http(httpOptions)
        .then(response => this.sendMessage(data.id, 'fetchRequest', response.data))
        .catch(() => this.sendMessage(data.id, 'fetchRequest', 'ERROR'))
    }
  }

  unRegisterWidget (id) {
    const registeredWidget = this.registered[id]
    if (registeredWidget) {
      //this.sendMessage(id, 'cancel', {});

      let stationId = registeredWidget.stationId || window.CONFIG.station_id

      registeredWidget.close()

      delete this.authorizationKeys[this.getAuthKeyCacheKey(id)]
      delete this.registered[id]

      if (!this.hasWidgetsOfStation(stationId)) {
        if (this.events[stationId]) {
          this.events[stationId].destroy()
          delete this.events[stationId]
        }
      }
    }
  }

  sendMessage (id, action, data) {
    let registeredData = this.registered[id]
    if (registeredData) {
      registeredData.iframe.contentWindow.postMessage({
        id: id,
        action: action,
        actionData: data,
      }, '*')
    }
  }

  getOrigin (url) {
    let parser = document.createElement('a')
    parser.href = url
    return parser.protocol + '//' + parser.host
  }

  saveWidgetsForTypeId (typeId) {
    return new Promise(resolve => {
      let widgets = this.getConnectionsFromTypeId(typeId)
      let promises = []

      for (let key in widgets) {
        if (widgets.hasOwnProperty(key)) {
          promises.push(widgets[key].save())
        }
      }

      Promise.all(promises).then(() => {
        resolve()
      })
    })
  }
}

Widgets.$inject = ['$rootScope', '$http', '$mdDialog', 'wsEvents']

module.exports = Widgets
